import { render } from "./OcrItemState.vue?vue&type=template&id=5ce5c92a"
import script from "./OcrItemState.vue?vue&type=script&lang=js"
export * from "./OcrItemState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__